import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const INCREMENT_STREAK_ON_GAME_PLAY_MUTATION = gql`
  mutation incrementStreakOnGamePlay($userId: String!) {
    incrementStreakOnGamePlay(userId: $userId) {
      _id
      userId
      currentStreak
      longestStreak
      lastUpdatedAt
      history {
        streakCount
        earnedAt
      }
    }
  }
`;

export interface IncrementStreakOnGamePlayMutationType {
  incrementStreakOnGamePlay: {
    _id: string;
    userId: string;
    currentStreak: number;
    longestStreak: number;
    lastUpdatedAt?: string;
    history: {
      streakCount: number;
      earnedAt: string;
    }[];
  };
}

export interface IncrementStreakOnGamePlayVariables {
  userId: string;
}

export function useIncrementStreakOnGamePlayMutation(
  options?: MutationHookOptions<
    IncrementStreakOnGamePlayMutationType,
    IncrementStreakOnGamePlayVariables
  >,
) {
  return useMutation<IncrementStreakOnGamePlayMutationType, IncrementStreakOnGamePlayVariables>(
    INCREMENT_STREAK_ON_GAME_PLAY_MUTATION,
    options,
  );
}
